module.exports = __webpack_public_path__ + "static/assets/c0325bd8816bed05921abf16aee445e2.png";